<template>
  <div v-if="pageCount" class="pdf-paginator d-none d-xl-flex">
    <template>
      {{ value }} / <span>{{ pageCount }}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PDFPaginator',

  props: {
    value: {
      required: true
    },
    pageCount: Number,
  },

  methods: {
    input(event) {
      this.$emit('input', parseInt(event.target.value, 10));
    },
  },

  watch: {
    pageCount() {
      this.$emit('input', 1);
    },
  }
}
</script>

<style scoped>
.pdf-paginator {
  padding: 0.5rem 1rem;
  background: #545969;
  border-radius: 10px;
  color: #fff;
  width: 5rem;
  height: 40px;
  align-items: center;
  justify-content: center;
}
.pdf-paginator input {
  width: 50px;
  height: 40px;
  border-radius: 5px!important;
  border: 1px solid #797979!important;
  text-align: right!important;
  padding: 0 10px!important;
}
</style>
